"use client"

import React from "react"

import { useThemeContext } from "@/shared/components/providers/theme-provider"

type Props = {
  children: React.ReactNode;
}

export default function AuthLoginLayout({ children }: Props) {

  return (
    <div className="flex min-h-screen">
      <div className="flex w-full items-center justify-center lg:w-1/2 bg-bg-primary">
        {children}
      </div>
      <div className="hidden lg:block relative w-full lg:w-1/2 flex-1 p-10 bg-bg-primary">
        <div
          className="bg-no-repeat bg-cover bg-center h-full w-full px-[30px] rounded-[35px]"
          style={{ backgroundImage: `url(${"/images/bg-login.png"})` }}
        >
          <div className="flex flex-col justify-between p-[35px] 2xl:p-[77px] items-center h-full text-white">
            <div className="flex flex-col mb-[60px]">
              <h2 className="text-[32px] font-semibold font-poppins w-full">
                Sign Your Way – Fast, Flexible, and Effortless
              </h2>
              <p className="font-semibold font-inter 2xl:text-lg text-base leading-normal mt-5 w-full">
                Sign your documents with ease. Choose your
                preferred method and complete the process quickly,
                all in one place. Start signing today and simplify
                your workflow.
              </p>
            </div>
            <div className=" bg-white/25 p-6 rounded-2xl">
              <p className="font-normal font-inter text-justify leading-normal">
                Experience seamless digital signatures with our
                all-in-one platform. Say goodbye to paperwork and
                embrace the future of digital agreements
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
